export default __webpack_public_path__ + "static/media/cicdWebApps.94e9134d.md";